import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@emburse/ui-core';
import { ConfirmModal } from '@ReactComponents/ConfirmModal';
/**
 * When editing an Amex CPG virtual card, if you edit the amount, the balance is reset to 0
 * This is a confirmation modal to make sure that the user understands this
 * @param props.onConfirm Confirm button handler
 * @returns
 */
export const AmexBalanceResetConfirmModal = (props) => {
    const loading = useSelector((state) => state.cardsGatewayIssuingModal.loading);
    return (_jsxs(ConfirmModal, Object.assign({ headerText: "Reset Balance", confirmText: "Update", confirmButtonColor: "error", isLoading: Boolean(loading) }, props, { children: [_jsx(Typography, Object.assign({ gutterBottom: true }, { children: "You are trying to update this card's budget. This action will also reset the card's current balance to 0." })), _jsx(Typography, Object.assign({ style: { marginBottom: '30px' } }, { children: "Are you sure you want to perform the update and reset the card's balance?" }))] })));
};
